import { useMutation, useQueryClient } from "react-query";
import { axiosInstance } from "../../config/axios";
import { QueryKeys } from "../queryKeys";

async function deleteResponseCode(id: number): Promise<any> {
  const { data } = await axiosInstance.delete(`/ResponseCode/DeleteResponseCode?id=${id}`);
  return data;
}

export function useDeleteResponseCode() {
  const queryClient = useQueryClient();
  return useMutation((id: number) => deleteResponseCode(id), {
    onSuccess: () => {
      queryClient.invalidateQueries(QueryKeys.responseCodes);
    },
  });
}
